// This is a cache for extra data that needs to be cached and persisted 

import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { Snapshot } from './events.era';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { userActions } from './user.era';

export interface CacheState {
  snapshots: EntityState<Snapshot>
}

const makeInitialState = (): CacheState => ({
	snapshots: {
		ids: [],
		entities: {}
  }
})

export const cacheActions = createActionGroup({
	source: 'Cache',
	events: {
		'Cache Event Snapshot': (snapshot: Snapshot) => ({ snapshot }),
	}
})

export const snapshotAdapter = createEntityAdapter<Snapshot>()

export const cacheReducer = createReducer(
	makeInitialState(),
	on(cacheActions.cacheEventSnapshot, (state, { snapshot }) => ({
		...state,
		snapshots: snapshotAdapter.addOne(snapshot, state.snapshots)
	})),
	on(userActions.logout, (state) => makeInitialState())
)

export const cacheFeature = createFeature({
	name: 'cache',
	reducer: cacheReducer
})

export const cacheStateSelector = createFeatureSelector<CacheState>(cacheFeature.name)



